export const order = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    id: { en: 'Order No.', ko: '주문 번호', fr: '' },
    select: { en: 'Select', ko: '선택', fr: '' },
    distributorCode: { en: 'Distributor code', ko: '대리점 코드', fr: '' },
    distributorName: { en: 'Distributor name', ko: '대리점명', fr: '' },
    serverType: { en: 'Server type', ko: '서버 타입', fr: '' },
    count: { en: 'Count', ko: '수량', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    cost: { en: 'Price', ko: '금액', fr: '' },
    info: { en: 'Info', ko: '기타', fr: '' },
    buyerId: { en: 'Buyer ID', ko: '주문자 ID', fr: '' },
    requestDate: { en: 'Request Date', ko: '요청 날짜', fr: '' },
    approvalDate: { en: 'Approval Date', ko: '승인 날짜', fr: '' },
    cancelDate: { en: 'Cancel Date', ko: '취소 날짜', fr: '' },
    approverId: { en: 'Approver', ko: '승인자 ID', fr: '' },
    cancelledBy: { en: 'Cancelled By', ko: '취소자 ID', fr: '' },
    orderItems: { en: 'Order Items', ko: '주문 항목', fr: '' },
  },
  info: {
    askApprove: { en: 'Confirm approval?', ko: '승인하시겠습니까?', fr: '' },
    search: { en: 'Search', ko: '검색', fr: '' },
    addOrder: { en: 'Add', ko: '추가', fr: '' },
    no: { en: 'No.', ko: '번호', fr: '' },
    id: { en: 'Order No.', ko: '주문 번호', fr: '' },
    select: { en: 'Select', ko: '선택', fr: '' },
    distributorCode: { en: 'Distributor code', ko: '대리점 코드', fr: '' },
    serverType: { en: 'Server type', ko: '서버 타입', fr: '' },
    count: { en: 'Count', ko: '수량', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    cost: { en: 'Price', ko: '금액', fr: '' },
    info: { en: 'Info', ko: '기타', fr: '' },
    buyerId: { en: 'Buyer ID', ko: '주문자 ID', fr: '' },
    requestDate: { en: 'Request Date', ko: '요청 날짜', fr: '' },
    approvalDate: { en: 'Approval Date', ko: '승인 날짜', fr: '' },
    cancelDate: { en: 'Cancel Date', ko: '취소 날짜', fr: '' },
    approverId: { en: 'Approver', ko: '승인자 ID', fr: '' },
    cancelledBy: { en: 'Cancelled By', ko: '취소자 ID', fr: '' },
    orderItems: { en: 'Order Items', ko: '주문 항목', fr: '' },
    totalCost: { en: 'Total Price', ko: '총 금액', fr: '' },
    totalCount: { en: 'Total Count', ko: '총 수량', fr: '' },
    distributor: { en: 'Distributor', ko: '대리점', fr: '' },
    distributorName: { en: 'Distributor name', ko: '대리점명', fr: '' },
  },
  placeHolder: {
    serial: { en: 'Serial', ko: '시리얼을 입력하세요', fr: '' },
    comment: { en: 'Comment', ko: '반려 사유를 입력하세요', fr: '' },
    id: { en: 'Order No.', ko: '주문번호를 입력하세요', fr: '' },
    distributorCode: { en: 'Distributor Code', ko: '대리점 코드를 입력하세요', fr: '' },
    distributorName: { en: 'Distributor Name', ko: '대리점명을 입력하세요', fr: '' },
  },
};
